import { apiClient } from './api.client';
import { API_ENDPOINTS } from '../config/api.config';
import { TripFinanceReport, MonthlyFinanceReport, YearlyFinanceReport, FinanceSummary } from '../types';

export const financeReportService = {
  getTripReport: async (tripId: number): Promise<TripFinanceReport> => {
    const response = await apiClient.get<TripFinanceReport>(API_ENDPOINTS.FINANCE_REPORTS.TRIP(tripId));
    return response.data;
  },

  getTripsReport: async (startDate: string, endDate: string): Promise<TripFinanceReport[]> => {
    const response = await apiClient.get<TripFinanceReport[]>(API_ENDPOINTS.FINANCE_REPORTS.TRIPS, {
      params: { startDate, endDate },
    });
    return response.data;
  },

  getMonthlyReport: async (year: number, month: number): Promise<MonthlyFinanceReport> => {
    const response = await apiClient.get<MonthlyFinanceReport>(API_ENDPOINTS.FINANCE_REPORTS.MONTHLY, {
      params: { year, month },
    });
    return response.data;
  },

  getYearlyReport: async (year: number): Promise<YearlyFinanceReport> => {
    const response = await apiClient.get<YearlyFinanceReport>(API_ENDPOINTS.FINANCE_REPORTS.YEARLY, {
      params: { year },
    });
    return response.data;
  },

  getSummary: async (startDate: string, endDate: string): Promise<FinanceSummary> => {
    const response = await apiClient.get<FinanceSummary>(API_ENDPOINTS.FINANCE_REPORTS.SUMMARY, {
      params: { startDate, endDate },
    });
    return response.data;
  },
};
